import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import useFullScreen from '../../hooks/useFullscreen'
import { useContentLayout } from '../../context/ContentLayout'
import {
    ArrowLeftIcon,
    ArrowsPointingOutIcon,
    PlusIcon,
    MinusIcon,
    DocumentTextIcon,
    DocumentMinusIcon
} from '@heroicons/react/24/outline'

const Toolbar = ({
    content,
    dilutionsData,
    currentDilution,
    setCurrentDilution,
    resetColumn,
    resetFontsize,
    capsuleName,
    capsuleId,
    customerName
}) => {
    const { lastCorrectConfig, layoutConfig, addColumn, removeColumn, addFontsize, removeFontsize } = useContentLayout()
    const { toggleFullScreen } = useFullScreen()
    const navigate = useNavigate()
    const location = useLocation()

    const handleBack = () => {
        // If last page history contains /admin/capsules, navigate to /admin/capsules
        if (location.pathname.includes('/admin/capsules')) {
            navigate('/capsules')
        } else {
            navigate('/admin/capsules')
        }
    }
    return (
        <>
            <div className="bg-primary p-4 opacity-0 hover:opacity-100 flex items-center gap-4 absolute top-0 left-0 w-1/2 z-[1] transition-all transition-duration-300  ">
                <button className="p-2 hover:bg-primary-focus rounded-lg cursor-pointer group hover:bg-base-200" onClick={handleBack}>
                    <ArrowLeftIcon className="w-6 h-6 text-white group-hover:text-primary" />
                </button>


                {/* Dilution Buttons - moved to replace version dropdown */}
                <div className="flex items-center gap-2">
                    {content && dilutionsData
                        .sort((a, b) => a.sort - b.sort)
                        .map((dilution, index) => {
                            const isDilutionPresent = content.some(item => {
                                if (item?.dilution?.label === dilution.letter) {
                                    return true;
                                }
                                if (!item?.dilution && item?.mixture?.defaultDilution?.label === dilution.letter) {
                                    return true;
                                }
                                return false;
                            });

                            if (isDilutionPresent) {
                                return (
                                    <button
                                        key={index}
                                        onClick={() => {
                                            console.log(dilution)
                                            if (currentDilution !== dilution) {
                                                setCurrentDilution(dilution);
                                                resetColumn();
                                                resetFontsize();
                                            }
                                        }}
                                        className={`
                                            px-3 py-1.5 rounded-md font-medium transition-colors
                                            ${currentDilution === dilution
                                                ? 'bg-sky-400 text-white'
                                                : 'bg-white text-primary hover:bg-gray-100'
                                            }
                                        `}
                                    >
                                        {dilution.letter}
                                    </button>
                                );
                            }
                            return null;
                        })}
                </div>

                <div className="flex items-center gap-3">
                    <button className="p-2 hover:bg-primary-focus rounded-lg cursor-pointer group hover:bg-base-200" onClick={toggleFullScreen}>
                        <ArrowsPointingOutIcon className="w-6 h-6 text-white group-hover:text-primary" />
                    </button>

                    <button className="p-2 hover:bg-primary-focus rounded-lg cursor-pointer group hover:bg-base-200" onClick={addFontsize}>
                        <DocumentTextIcon className="w-6 h-6 text-white group-hover:text-primary" />
                    </button>

                    <button className="p-2 hover:bg-primary-focus rounded-lg cursor-pointer group hover:bg-base-200" onClick={removeFontsize}>
                        <DocumentMinusIcon className="w-6 h-6 text-white group-hover:text-primary" />
                    </button>

                    <button className="p-2 hover:bg-primary-focus rounded-lg cursor-pointer group hover:bg-base-200" onClick={addColumn}>
                        <PlusIcon className="w-6 h-6 text-white group-hover:text-primary" />
                    </button>

                    <button className="p-2 hover:bg-primary-focus rounded-lg cursor-pointer group hover:bg-base-200" onClick={removeColumn}>
                        <MinusIcon className="w-6 h-6 text-white group-hover:text-primary" />
                    </button>
                </div>

                {/* Capsule and Customer Info - moved to the right */}
                <div className="ml-auto text-white text-2xl font-medium">
                    {capsuleName && capsuleId && customerName && (
                        <span>{capsuleName} {capsuleId} - {customerName}</span>
                    )}
                </div>
            </div>
        </>
    )
}

export default Toolbar
